import manifest from "./manifest.js";

const aliases = {
  [manifest.SABLIER_FLOW]: "FL4",
};

export default aliases;
